export const resolveRoomCosmeticValue = ({
  hasActiveRoom,
  authoritativeValue,
  localValue,
  fallbackValue,
}) => {
  const serverValue = String(authoritativeValue || "").trim();
  const savedValue = String(localValue || "").trim();
  const fallback = String(fallbackValue || "").trim();

  // Once a match has a room, only the server-effective profile may select a
  // cosmetic. Falling back to the saved local preference here would let the
  // losing client re-enable a duplicate model between authoritative snapshots.
  if (hasActiveRoom) return serverValue || fallback;

  return serverValue || savedValue || fallback;
};

export const normalizeRoomCosmeticRevision = (value) => {
  const numericValue = Number(value);
  if (!Number.isSafeInteger(numericValue) || numericValue <= 0) return 0;
  return numericValue;
};

export const shouldAcceptRoomCosmeticRevision = ({
  currentRevision,
  incomingRevision,
}) => {
  const current = normalizeRoomCosmeticRevision(currentRevision);
  const incoming = normalizeRoomCosmeticRevision(incomingRevision);

  if (current <= 0) return true;
  if (incoming <= 0) return false;
  return incoming >= current;
};
